import { useAccount, useMsal } from '@azure/msal-react';

export function useCurrentAccount() {
  const { accounts } = useMsal();
  return useAccount(accounts[0] || {});
}
